import "./polyfills";
import React, { Component } from "react";
import ComponentLoading from "./ComponentLoading";
import ComponentError from "./ComponentError";
import SessionManager from "./SessionManager";
import { ReactPlugin, withAITracking } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";

export default class WidgetBase extends Component {

    constructor(props) {

        super(props);

        this.sessionManager = new SessionManager();
        this.moment = require("moment");
        this.momentTZ = require("moment-timezone");
        const widgetData = this.sessionManager.GetSessionData(this.props.sessionName),
            selectedCulture = this.getCookie("CultureCode");

        if (selectedCulture === null) {

            selectedCulture = "en-US";

        }

        this.appInsights = window.appInsights;

        if (this.appInsights != null) {

            const browserHistory = createBrowserHistory({ "basename": "" }),
                plugin = new ReactPlugin();
            this.appInsights.config.extensions = { plugin };
            this.appInsights.config.extensionConfig = { [plugin.identifier]: { "history": browserHistory } };
            this.reactAppInsights = plugin;

        }

        this.state = {
            "cultureCode": selectedCulture,
            "jsonData": widgetData,
            "dataError": false,
            "errorText": null,
            "retries": 0
        };

    }

    componentDidMount() {

        this.loadData();

    }

    loadData() {

        if (this.props.initialData) {

            const { jsonData } = this.state;
            if (jsonData === null) {

                const dataNames = [],
                    fetches = [],
                    urls = this.props.initialData;
                Object.keys(urls).forEach((key) => {

                    Object.keys(urls[key]).forEach((key2) => {

                        dataNames.push(key2);
                        fetches.push(fetch(urls[key][key2]));

                    });

                });

                Promise.all(fetches).then((response) => Promise.all(response.map((r) => r.json()))).
                    then((data) => {

                        const obj = new Object();
                        for (let i = 0; i < data.length; ++i) {

                            obj[dataNames[i]] = data[i];

                        }

                        this.setState({ "jsonData": obj });
                        this.sessionManager.SetSessionData(
                            this.props.sessionName,
                            obj
                        );

                    }).
                    catch((error) => {

                        this.setState({
                            "dataError": true
                        });

                    });

            }

        }

    }

    updateSession(dataName, newData) {

        let ses = this.sessionManager.GetSessionData(this.props.sessionName);
        if (ses) {
            ses[dataName] = newData
        } else {
            ses = { [dataName]: newData }
        }
        this.sessionManager.SetSessionData(
            this.props.sessionName,
            ses
        );

    }

    getCookie(name) {

        const value = `; ${document.cookie}`,
            parts = value.split(`; ${name}=`);
        if (parts.length === 2) {

            return parts.pop().split(";").
                shift();

        }

    }

    getErrorText() {

        fetch("/api/PageContent/GetWidgetText/28").
            then((response) => response.json()).
            then((data) => this.setState({ "errorText": data }));

    }

    styleText(text) {

        if (text && text.includes("</")) {

            return (<>
                {this.tagParser(text)}
            </>);

        }

        return text;


    }

    tagParser(text) {

        const match = text.match(/<strong>|<em>|<i>|<u>|<br>|<indent>|<indentx>|<red>|<email>/);

        if (!match) {

            return <>
                {text}
            </>;

        }

        const tag = match[0];

        if (text.indexOf(match) > 0) {

            return <><>{text.substring(0, text.indexOf(tag))}</><React.Fragment>
                {this.tagParser(text.substring(text.indexOf(tag)))}
            </React.Fragment></>;

        }

        if (tag === "<strong>") {

            const close = "</strong>";
            return <>
                <strong>{this.tagParser(text.substring(tag.length, text.indexOf(close)))}</strong>{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;

        } else if (tag === "<red>") {

            const close = "</red>";
            return <>
                <span style={{ color: '#FF0000' }}>{this.tagParser(text.substring(tag.length, text.indexOf(close)))}</span>{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;

        } else if (tag === "<indent>") {

            const close = "<indent>";
            return <>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;

        } else if (tag === "<indentx>") {

            const close = "<indentx>";
            return <>
                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;

        } else if (tag === "<br>") {

            const close = "<br>";
            return <>
                <br />{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;

        } else if (tag === "<em>") {

            const close = "</em>";
            return <>
                <em>{this.tagParser(text.substring(tag.length, text.indexOf(close)))}</em>{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;

        } else if (tag === "<i>") {

            const close = "</i>";
            return <>
                <i className="material-icons">{this.tagParser(text.substring(tag.length, text.indexOf(close)))}</i>{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;


        } else if (tag === "<u>") {

            const close = "</u>";
            return <>
                <u>{this.tagParser(text.substring(tag.length, text.indexOf(close)))}</u>{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;

        } else if (tag === "<email>") {

            const close = "</email>";
            var who = text.substring(tag.length, text.indexOf(close));
            var sendto = "mailto:" + who;
            return <>
                <a href={sendto}>{this.tagParser(text.substring(tag.length, text.indexOf(close)))}</a>{this.tagParser(text.substring(text.indexOf(close) + close.length))}</>;

        }

    }

    displayErrorWidget(reloadFunction) {

        const { retries } = this.state,
            { errorText } = this.state;

        if (!errorText) {

            this.getErrorText();

        }

        if (retries >= 3) {

            if (this.appInsights != null) {

                this.appInsights.trackTrace({ "message": errorText });

            }

        }

        return (
            errorText
                ? <ComponentError
                    pageText={errorText}
                    retry={() => this.handleOnClickRetryWidgetLoad(reloadFunction)}
                    support={retries >= 3}
                /> : null
        );

    }

    displayPartInfoModalLink(partNumber, onClick, toolTip) {

        return (
            <a
                data-backdrop="static"
                data-target="#partInformationModal" // Todo: add to common text store
                data-toggle="modal"
                href="#"
                onClick={() => onClick()}
                title={toolTip ? toolTip : "Click for Part Information"}
            >
                {partNumber}
            </a>
        );

    }

    displayDemandHistoryModalLink(onClick) {

        return (
            <a
                className="demandHistoryModal"
                data-target="#partDemandHistoryModal" // Todo: add to common text store
                data-toggle="modal"
                onClick={() => onClick()}
                title="Click for Part Demand History"
            >
                <i className="material-icons">
                    library_books
                </i>
            </a>
        );

    }

    handleOnClickRetryWidgetLoad(callBack) {

        const retryCount = this.state.retries + 1;

        this.setState({
            "dataError": false,
            "retries": retryCount
        });

        return callBack();

    }
    dealerTimeZoneConvertor(date, format) {

        if (this.props.sessionInfo.selected) {
            return this.momentTZ.utc(date).tz(this.props.sessionInfo.selected.TimeZoneCity).format(format);
        }

    }

    render() {

        const { dataError } = this.state,
            receivedData = this.state.jsonData,
            culture = this.state.cultureCode,
            getInitialData = Boolean(this.props.initialData);

        this.moment.locale(culture);

        if (dataError) {

            return this.displayErrorWidget(this.loadData);

        }

        if (getInitialData && receivedData === null) {

            return <ComponentLoading />;

        }

        return (
            React.cloneElement(
                this.props.children,
                {
                    "data": receivedData,
                    culture,
                    "inventoryPK": this.props.inventoryPK,
                    "currencySymbol": this.props.currencySymbol,
                    "makePK": this.props.makePK,
                    "dealerTimeZone": this.props.dealerTimeZone,
                    "dealerTitle": this.props.dealerTitle,
                    "dateFormatter": this.moment,
                    "styleText": (t) => this.styleText(t),
                    "displayError": (f) => this.displayErrorWidget(f),
                    "displayPartInformationLink": (p, c, t) => this.displayPartInfoModalLink(
                        p,
                        c,
                        t
                    ),
                    "displayDemandHistoryModalLink": (c) => this.displayDemandHistoryModalLink(c),
                    "updateSession": (n, d) => this.updateSession(
                        n,
                        d
                    ),
                    "dealerCode": this.props.dealerCode,
                    "userName": this.props.userName,
                    "pageText": this.props.pageText,
                    "userPermissions": this.props.userPermissions,
                    "sessionInfo": this.props.sessionInfo,
                    "dealerTimeZoneConvertor": (d, f) => this.dealerTimeZoneConvertor(
                        d,
                        f
                    )
                }
            )
        );

    }

}
